export default {
  async setSidebarOpen({ commit }, payload) {
    return commit('SET_SIDEBAR_OPEN', payload)
  },
}
